import { Button, Collapse } from "antd";
import { useEnums } from "../../../hooks";
import { PlusOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import SearchBar from "./SearchBar";
import EnumDetails from "./EnumDetails";
import Empty from "../Empty";
import emptyImage from "assets/svg/emptyImg.svg";
import EmptyComponent from "components/EmptyComponent";

export default function EnumsTab() {
  const { enums, addEnum } = useEnums();
  const { t } = useTranslation();

  return (
    <div>
      <div className="flex gap-2">
        <SearchBar />
        <div>
          <Button icon={<PlusOutlined />} block onClick={() => addEnum()}>
            {t("add_enum")}
          </Button>
        </div>
      </div>
      {enums.length <= 0 ? (
        <EmptyComponent image={emptyImage} description="在此定义列举" />
      ) : (
        <Collapse 
          accordion
          items={enums.map((e, i) => ({
            key: `${i}`,
            label: (
              <div className="overflow-hidden text-ellipsis whitespace-nowrap">
                {e.name}
              </div>
            ),
            children: <EnumDetails data={e} i={i} />,
          }))}
        />
      )}
    </div>
  );
}
